module.exports = __webpack_public_path__ + "img/456.0d6da97a.png";